export enum TaxiCorporationAddRequestContractMaintenancePolicy {
  BASIC = "BASIC",
  AUCTION = "AUCTION",
}

export type TaxiCorporationAddRequestBody = {
  taxId: string;
  regon: string | null;
  krsNo: string | null;
  companyName: string;
  displayName: string;
  headquartersAddressString: string;
  contractMaintenancePolicy: TaxiCorporationAddRequestContractMaintenancePolicy;
  notes: string;
};

type TaxiCorporationAddRequest = {
  taxId: string;
  regon: string | null;
  krsNo: string | null;
  companyName: string;
  displayName: string;
  headquartersAddressString: string;
  contractMaintenancePolicy: TaxiCorporationAddRequestContractMaintenancePolicy;
  notes: string;
};

export default TaxiCorporationAddRequest;
